import styled from '@emotion/styled'
import Column from 'components/core/Column'
import Row from 'components/core/Row'
import { DESIGN_TOKENS } from 'constants/color.constants'
import { SPACING } from 'constants/spacing.constants'
import { Outlet } from 'react-router-dom'
import { getImageUrl } from 'utils/getImageUrl'
import { BACKGROUND_VIDEO_URL } from '../loginForm.constants'

const StyledLoginLayoutDesktop = styled(Row)`
    position: fixed;
    inset: 0;
    height: 100vh;
    height: 100dvh;
`

const StyledBackgroundVideo = styled.video`
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    opacity: 0.24;
    background-color: ${DESIGN_TOKENS.background.primary};
    transform: scale(1.04);
    object-position: calc(50% - 3rem) center;
`

const StyledColumn = styled(Column)`
    position: relative;
    z-index: 1;
    background-color: transparent;

    .loginLayoutDesktop__body__logo {
        height: 2.4rem;
    }

    .loginLayoutDesktop__body__text {
        color: ${DESIGN_TOKENS.text.foreground};
        font-family: Inter;
        font-size: 3rem;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 0;
    }

    .loginLayoutDesktop__body__card {
        border-radius: ${DESIGN_TOKENS.borderRadius.sm};
        margin: ${SPACING.p3};
        padding: ${SPACING.p3};
        background-color: ${DESIGN_TOKENS.background.primary};
        border: 1px solid ${DESIGN_TOKENS.border.input};
        min-width: 400px;
    }
`

export const LoginLayoutDesktop = () => {
    return (
        <StyledLoginLayoutDesktop>
            <StyledBackgroundVideo
                autoPlay
                loop
                muted
                playsInline
                src={BACKGROUND_VIDEO_URL}
            />
            <StyledColumn
                fullHeight
                fullWidth
                className="loginLayoutDesktop__body"
                alignItems="center"
                justifyContent="center"
                gap="sm"
            >
                <Row alignItems="center" justifyContent="center" gap="sm">
                    <img
                        className="loginLayoutDesktop__body__logo"
                        alt="Logo"
                        src={getImageUrl('shortLogoWhite.png')}
                    />
                    <p className="loginLayoutDesktop__body__text">Cartage</p>
                </Row>
                <div className="loginLayoutDesktop__body__card">
                    <Outlet />
                </div>
            </StyledColumn>
        </StyledLoginLayoutDesktop>
    )
}
